module.exports = __webpack_public_path__ + "img/ResumeTemp5.1f4482b8.png";